export default "__VITE_ASSET__Bf02wovO__"